import * as math from 'mathjs';
// 联动相关的代码
export default {
  methods: {
    dragResule(formula, formdata,detailKey){
      let that = this
      // let inputString = formula.toLowerCase(); //方法名改成小写
      let dataArr = []
      // 明细控件-函数计算
      if(detailKey){
        const nn = []
        for (const value of this.property) {
          if (detailKey.key == value.title + '_' + value.type) {
            if (value.list && value.list.length > 0) {
              for (const d of value.list) {
                // 如果有关联单选并且里面有子控件的话，提出来
                if (d.type === 'new-rel-radio' && d.list && d.list.length > 0) {
                  for (const ee of d.list) {
                    const eea = JSON.parse(JSON.stringify(ee))
                    eea.name = d.name + '.' + eea.name
                    nn.push(eea)
                  }
                }
              }
            }
            dataArr.push(JSON.parse(JSON.stringify(value)))
          }
        }
        if (nn.length > 0) {
          dataArr[0].list = dataArr[0].list.concat(nn)
        }
      } else{
        for (const aa of that.property) {
          dataArr.push(aa)
          if (aa.type === 'new-rel-radio' && aa.list && aa.list.length > 0) {
            for (const aae of aa.list) {
              const eeaa = JSON.parse(JSON.stringify(aae))
              eeaa.name = aa.name + '.' + eeaa.name
              dataArr.push(eeaa)
            }
          }
        }
      }
      // 遍历数组并构建表达式
      let expression = formula.replace(/<[^>]+>/g, function(match) {
        let valName = match.replace(/<|>/g, '');
          // 在 JSON 数据中查找与变量名称匹配的属性
        let foundItem = ''
        if(detailKey){
          foundItem = dataArr[0].list.find(function(item) {
            return valName === dataArr[0].name + '.' + item.name
          });
        } else{
          foundItem = dataArr.find(function(item) {
            return valName === item.name
          });
        }
        if (foundItem) {
            // 如果找到匹配的属性，构建相应的表达式部分
            // return `formdata['${foundItem.title + '_' + foundItem.type}']`; 完整字段名
            // 直接返回对应字段的值
            return formdata[foundItem.title +  '_' + foundItem.type]
        } else {
            // 如果找不到匹配的属性，保持原始字符串
            // return match;
            // 如果找不到则返回0或者空字符
            if(foundItem.type === 'number'){
              return 0
            } else{
              return ''
            }
        }
      });
      return `${expression}`;
    },
    // 函数计算-所有函数列表
    mathFunRun(val, mathFun){
      // 多个文本合并，使用数组进行拼接
      let countArr = val.split(",")
      let concatenatedString = ''
      let resultVal = ''
      let undefinedLen = 0
      for(let i = 0; i < countArr.length; i++){
        if(countArr[i] != 'undefined'){
          concatenatedString += countArr[i]
        }
        else undefinedLen++
      }
      if(undefinedLen == countArr.length){
        return resultVal = undefined
      }
      switch (mathFun) {
        case "IF":
          // IF三元运算
          resultVal = this.evaluateCondition(countArr)
          break;
        case "SUM":
          // 求和
          resultVal = math.evaluate('sum('+val+')')
          break;
        case "MAX":
          // 最大数
          resultVal = math.evaluate('max('+val+')')
          break;
        case "MIN":
          // 最小数
          resultVal = math.evaluate('min('+val+')')
          break;
        case "MOD":
          // 两数相除的余数
          resultVal = math.evaluate('mod('+val+')')
          break;
        case "AVG":
          // 平均值
          resultVal = math.evaluate('mean('+val+')')
          resultVal = resultVal.toFixed(2)
          break;
        case "ABS":
          // 绝对值
          resultVal = math.evaluate('abs('+val+')')
          break;
        case "CONCAT":
          if(this.containsOperator(val)){
            // 加减乘除计算
            resultVal = math.evaluate(val)
          }
          else{
            // 多个文本合并
            resultVal = math.concat(concatenatedString)
          }
          break;
        case "ROUND": {
          // 小数点格式化
          const index = val.indexOf(',')
          if (index === -1) {
            // 字符串中不包含逗号
            resultVal = math.round(val)
          } else {
            const before = val.substring(0, index);
            const after = val.substring(index + 1);
            resultVal = math.round(before, after)
          }
          break;
        }
        default:
          break;
      }
      return resultVal;
    },
    // 正则表达式匹配 +、-、* 或 /
    containsOperator(str) {
      // 匹配：数字（可能为负数、小数） + 运算符 + 数字
      return /^-?\d+(\.\d+)?(\s*[+\-*/]\s*-?\d+(\.\d+)?)+$/.test(str);
    },
    // 函数运算if三元运算
    evaluateCondition(arr) {
      console.log(arr, 'countArrcountArr')

      const condition = arr[0];
      const trueValue = arr[1].replace(/"/g, '');
      const falseValue = arr[2].replace(/"/g, '');
      let result;
      if (condition.includes('>') && !condition.includes('>=')) { //大于
        const operands = condition.split('>');
        const leftOperand = parseFloat(operands[0]);
        const rightOperand = parseFloat(operands[1]);
        if(isNaN(leftOperand) || isNaN(rightOperand)) result = '';
        else result = leftOperand > rightOperand ? trueValue : falseValue;
      } else if (condition.includes('>=')) { //大于等于
        const operands = condition.split('>=');
        const leftOperand = parseFloat(operands[0]);
        const rightOperand = parseFloat(operands[1]);
        if(isNaN(leftOperand) || isNaN(rightOperand)) result = '';
        else result = leftOperand >= rightOperand ? trueValue : falseValue;
      } else if (condition.includes('<') && !condition.includes('<=')) { //小于
        const operands = condition.split('<');
        const leftOperand = parseFloat(operands[0]);
        const rightOperand = parseFloat(operands[1]);
        if(isNaN(leftOperand) || isNaN(rightOperand)) result = '';
        else result = leftOperand < rightOperand ? trueValue : falseValue;
      } else if (condition.includes('<=')) { //小于等于
        const operands = condition.split('<=');
        const leftOperand = parseFloat(operands[0]);
        const rightOperand = parseFloat(operands[1]);
        if(isNaN(leftOperand) || isNaN(rightOperand)) result = '';
        else result = leftOperand <= rightOperand ? trueValue : falseValue;
      } else if (condition.includes('!=')) { //不等于
        const operands = condition.split('!=');
        const leftOperand = parseFloat(operands[0]);
        const rightOperand = parseFloat(operands[1]);
        if(isNaN(leftOperand) || isNaN(rightOperand)) result = '';
        else result = leftOperand != rightOperand ? trueValue : falseValue;
      } else if (condition.includes('=')) { //等于
        const operands = condition.split('=');
        const leftOperand = parseFloat(operands[0]);
        const rightOperand = parseFloat(operands[1]);
        if(isNaN(leftOperand) || isNaN(rightOperand)) result = '';
        else result = leftOperand == rightOperand ? trueValue : falseValue;
      } else {
        // 未知条件
        console.log("所有IF条件都不匹配，请重试");
      }
      return result;
    },
    // 获取<>内的数据
    getDataWithinBrackets(str) {
      const regex = /<(.+?)>/g;
      let match;
      const results = [];
      
      while ((match = regex.exec(str))) {
        results.push(match[1]); // 添加到结果数组中，match[1] 是捕获组的内容
      }
      
      return results;
    }
  }
}